module.exports = __webpack_public_path__ + "img/mountedcrane_driving.0f018220.svg";